// removed by extract-text-webpack-plugin
module.exports = {"closed":"SideBar__closed___3mkpj","taskbar":"SideBar__taskbar___DCNAJ","header":"SideBar__header___3qgGe","toggleCompleted":"SideBar__toggleCompleted___TsoWX","taskSection":"SideBar__taskSection___18AfJ","tabs":"SideBar__tabs___dW0XU","tab":"SideBar__tab___1LE9B","tabscontainer":"SideBar__tabscontainer___3B8Yb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SideBar/SideBar.scss
// module id = 1192
// module chunks = 1